<template>
	<div>
		<div class="title-container">
			<div class="title">Email Verification</div>
		</div>
		<div class="input-container">
			<div class="input-static-text">{{ text }}</div>
		</div>
		<div v-if="!isEmailVerified" class="grid form two">
			<button v-show="!loading" @click.prevent="sendEmail" class="submit-standard good-bg">Send Verification<span class="fa fa-paper-plane"></span></button>
			<button v-show="loading" @click.prevent="sendEmail" class="submit-standard neutral-bg" disabled>Sending Email<span class="fa fa-sync fa-spin"></span></button>
			<button v-show="!loadingCheck" @click.prevent="checkVerification" class="submit-standard neutral-bg">Check Status<span class="fa fa-paper-plane"></span></button>
			<button v-show="loadingCheck" class="submit-standard neutral-bg" disabled>Checking Status<span class="fa fa-sync fa-spin"></span></button>
		</div>
		<div v-else>
			<button @click.prevent="go" class="submit-standard neutral-bg">Go to {{ isLoggedIn ? 'Dashboard' : 'Log In' }}<span class="fa fa-chevron-right"></span></button>
		</div>
	</div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {

	name: 'EmailVerificationRequired',

	data() {
		return {
			loading: false,
			loadingCheck: false,
			intRef: null,
		};
	},

	computed: {

		...mapGetters([ 'isEmailVerified', 'isLoggedIn' ]),

		text() {
			if (this.isEmailVerified) {
				return 'Your email address has been verified!';
			}

			if (this.$route.query.failed) {
				return 'That verification token has expired';
			}

			return 'You must verify your email address';
		}
	},

	mounted() {
		this.startInterval();
	},

	beforeDestroy() {
		clearInterval(this.intRef);
	},

	methods: {

		startInterval() {
			if (this.intRef) {
				clearInterval(this.intRef);
			}

			this.intRef = setInterval(() => {
				this.checkVerification();
			}, 1000 * 15);
		},

		go() {
			this.$router.replace(this.isLoggedIn ? '/dashboard' : '/login');
		},

		async sendEmail() {
			this.loading = true;

			try {
				await this.$api.post('/user/send-email-verification');

				this.$store.dispatch('addToast', 'Email Verification Sent');
			} catch (e) {
				this.$store.dispatch('addToast', { message: 'There was an issue re-sending your email verification', type: 'bad-bg' });
			}

			this.loading = false;
		},

		async checkVerification() {
			this.loadingCheck = true;

			await this.$store.dispatch('getAccounts');

			this.$nextTick(() => {
				if (this.isEmailVerified) {
					clearInterval(this.intRef);
				}
			});

			this.loadingCheck = false;
		}
	}

};

</script>
